// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"0355b264","450":"355a5eae","720":"0fc3ef81","893":"4a48a5ec"}[chunkId] + ".chunk.js";
};